import classNames from 'classnames';
import React, { FC } from 'react';
import {
  VirtualizedTableCellProps,
  VirtualizedTableColType,
} from './VirtualizedTable.interface';
import moment from 'moment';
import { Tooltip } from '../Tooltip/Tooltip';

export interface VirtualizedDisplayCellProps {
  cell: VirtualizedTableCellProps;
  editable: boolean;
  columnType: VirtualizedTableColType;
  onClick?: () => void;
}

export const VirtualizedDisplayCell: FC<VirtualizedDisplayCellProps> = ({
  cell,
  editable,
  columnType,
  onClick,
}) => {
  const handleOnClick = () => {
    if (onClick) {
      onClick();
    }
  };

  const content = (
    <span>
      {(columnType === VirtualizedTableColType.Number ||
        columnType === VirtualizedTableColType.String) &&
        cell.value}
      {columnType === VirtualizedTableColType.Date &&
        moment(cell.value as string).isValid() &&
        moment(cell.value as string).format('LLL')}

      {columnType === VirtualizedTableColType.Mulitselect && cell.value}
    </span>
  );

  return (
    <div
      role={cell.onClick !== undefined ? 'button' : 'note'}
      tabIndex={-1}
      className={classNames('virtualized-table-cell', {
        clickable: cell.onClick !== undefined,
        editable: editable,
      })}
      onClick={handleOnClick}
      onKeyDown={handleOnClick}
    >
      {cell.showTooltip ? (
        <Tooltip key={cell.key} content={content} trigger={content} />
      ) : (
        content
      )}
    </div>
  );
};
